import { useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { useExistingSRs, useLinkedSrsLists } from 'remote-state/ticketServiceHooks';
import useQueueData from 'remote-state/useQueueData';
import { setSearchSrParams } from 'features/queue/slice';
import { useGetSuggestedCategories } from 'features/queue/grid/hooks/useGetSuggestedCategories';
import useQueueWebSocketDataSync from 'remote-state/web-sockets/useQueueWebSocketDataSync';

export const useGridDataSource = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  useGetSuggestedCategories();

  const { data: queueData } = useQueueData();

  const srIds = useMemo(() => {
    if (!queueData?.ticketsLockMap) {
      return [];
    }
    return Object.keys(queueData.ticketsLockMap).map(Number);
  }, [queueData]);

  const { srsCombined, templatesMap } = useExistingSRs(srIds);

  useLinkedSrsLists({
    srs: srsCombined,
    templatesMap,
  });

  useQueueWebSocketDataSync();

  useEffect(
    () => () => {
      if (typeof global === 'undefined') {
        window.global = window;
      }
      global.queueAbortController?.abort(); // cancel on going requests because grid is unmounted
      dispatch(setSearchSrParams(null));
      delete global.queueAbortController;
    },
    [queryClient, dispatch],
  );
};
